import React from "react";
import AdminFeatureTour, {
  markTourSeen,
  shouldAutoStartTour,
} from "../../components/AdminFeatureTour";

export const RULES_TOUR_STORAGE_KEY = "vr_admin_rules_tour_seen_v1";

export const RULES_TOUR_STEPS = [
  {
    id: "welcome",
    target: "tour-theme-settings",
    title: "Welcome to Theme Rules",
    body: "This page is where you set a custom title, write the rules players read before the game, and pick the colors used throughout this theme.",
  },
  {
    id: "custom-rules",
    target: "tour-custom-rules",
    title: "Add custom rules",
    body: "Add 1 to 6 rules. Each rule can be up to 200 characters. At least one rule is required before you continue.",
  },
  {
    id: "page-content",
    target: "tour-page-content",
    title: "Page content",
    body: "Set points per correct answer and the colors used for text and buttons.",
  },
  {
    id: "save",
    target: "tour-actions",
    title: "Save and continue",
    body: "Click Next to save these settings and continue to game content (questions).",
  },
];

export default function RulesFeatureTour({ open, onClose }) {
  return <AdminFeatureTour open={open} onClose={onClose} steps={RULES_TOUR_STEPS} />;
}

export function markRulesTourSeen() {
  markTourSeen(RULES_TOUR_STORAGE_KEY);
}

export function shouldAutoStartRulesTour() {
  return shouldAutoStartTour(RULES_TOUR_STORAGE_KEY);
}
